module.exports = __webpack_public_path__ + "static/media/del_icon.9518c43d.svg";